<template>
  <div class="between_item between_right">
    <div class="side_content">
      <!-- <el-popconfirm title="这是一段内容确定删除吗？">
        <el-button slot="reference" class="side_item">删除</el-button>
      </el-popconfirm> -->
      <div slot="reference" class="side_item" @click="handleClickCheckOver(0)" v-if="showCheckOver">
        诊断完成
      </div>
    </div>
    <card title="待排查项" v-if="curWarmFromIndex">
      <div class="card_table" id="cardTable" :class="{ table2: curTable == 2 }">
        <el-table
          v-loading="isLoading"
          element-loading-text="数据加载中"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          :data="curUncheckListData"
          ref="tableRef"
          @row-click="clickTable1"
          :header-cell-style="TableHeadRowClass"
          :row-class-name="tableRowClassName"
          highlight-current-row
          :height="curTableHeight"
        >
          <el-table-column prop="NAME" label="故障名称" align="center"> </el-table-column>
          <!-- <el-table-column prop="ORD" label="位置" align="center">
            <template slot-scope="scope">
              {{ scope.row.ORD || '水电站' }}
            </template>
          </el-table-column> -->
          <el-table-column prop="DEVICE_NAME" label="设备名称" align="center"> </el-table-column>
          <el-table-column prop="CONFIDENCE" label="发生率" align="center" width="100">
            <template slot-scope="scope">
              {{ Math.floor(scope.row.CONFIDENCE * 10000) / 100 || '0' }}%
            </template>
          </el-table-column>
          <!-- <el-table-column prop="STATUS" label="状态" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.STATUS || '未排查' }}
            </template>
          </el-table-column> -->
          <div class="empty" slot="empty" v-show="isEmpty">
            <!-- <img
              class="Img"
              src="data:image/svg+xml;base64,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"
              alt=""
            /> -->
            <p>{{ emptyText }}</p>
          </div>
        </el-table>
      </div>
    </card>
    <card title="排查信息详情" styles="margin-top:24px" v-if="curTable == 2 && curWarmFromIndex">
      <div class="card_detail box_style">
        <div class="detail_list">
          <div class="list_item fs" v-for="(item, index) in detailList" :key="index">
            <div class="icon">
              <img class="Img" :src="`${require(`@/assets/hs/${item.icon}.png`)}`" alt="" />
            </div>
            <p class="name">{{ item.name }}</p>
            <p class="value">{{ item.value }}</p>
          </div>
        </div>
        <div class="btn_box fb">
          <div class="btn" @click="dealState(0)">未出现</div>
          <div class="btn" @click="dealState(1)">已出现</div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as Api from '@/api';
let timer;

const mockColor = [-1, 1, 2, 3, 2, 3, 1, -1, 2, 3, -1, 1, 3, 2, -1, 2, 1, 3];
const mockColorState = {
  SLJ010: { id: 'SLJ010', color: '1', info: '未出现' },
  SLJ011: { id: 'SLJ011', color: '1', info: '未出现' },
  SLQ001: { id: 'SLQ001', color: '-1', info: '已出现' },
  SLJ012: { id: 'SLJ012', color: '1', info: '未出现' },
};
export default {
  components: {
    Card,
  },
  data() {
    return {
      curTable: 1,
      detailList: [],
      curWarmFromIndex: null,
      curDeviceIndex: '',
      curDeviceData: {},
      curDeviceList: [],
      curAllTableData: [],
      curUncheckListData: [], //待排查项列表
      curTableHeight: 660,
      currentIndex: 0,
      curCheckTaskId: '',
      isEmpty: false,
      emptyText: '',
      curTaskId: '',
      curFaultInfo: null,
      isLoading: false,
      showCheckOver: false,
      curFaultTreeData: null,
      curRedDeviceCode: '',
      curCheckedRedDeviceList: [], //过滤出来的已排查且已出现的设备列表
    };
  },
  watch: {
    curWarmFromIndex(nV, oV) {
      console.log('nV,oV :>> ', nV, oV);
    },
    curCheckTaskId: {
      handler: function (newV, oldV) {
        console.log('newV :>> ', newV);
        if (newV) {
          this.curTaskId = newV;
          this.getNextstepData(this.curTaskId);
        }
      },
      immediate: true,
    },
    curTable: {
      handler: function (newV, oldV) {
        console.log('newV :>> ', newV);
        if (newV == 1) {
          this.curTableHeight = 660;
        } else {
          this.curTableHeight = 400;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.curWarmFromIndex = this.$Storage.get('warmFromIndex') || null;

    this.$bus.$on('warmFromIndex', (data) => {
      this.curWarmFromIndex = data;
      console.log('this.curWarmFromIndex,data :>> ', this.curWarmFromIndex, data);
    });
    this.$bus.$on('curTable', (data) => {
      this.curTable = data;
    });
    // 用来请求待排查项的任务id
    this.$bus.$on('checkTaskId', (data) => {
      this.curCheckTaskId = data;
    });
    // 用来请求诊断完成的参数
    this.$bus.$on('curFaultInfo', (data) => {
      console.log('data--------- :>> ', data);
      this.curFaultInfo = data;
    });
    this.$bus.$on('curRedDeviceCode', (data) => {
      console.log('this.curRedDeviceCode 222:>> ', data);
      this.curRedDeviceCode = data;
    });
  },
  methods: {
    //设置table表头的底色
    TableHeadRowClass({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: rgba(3, 74, 144, 0.3);color: rgba(190, 225, 249, 0.8);';
      } else {
        return '';
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    clickTable1(row) {
      this.curTableHeight = 400;
      const { index: rowIndex } = row;
      this.curDeviceData = this.curUncheckListData[rowIndex];
      const { DEVICE_NAME, ORD, ID, NAME, SOLUTION, INFO, modelDeviceCode } = this.curDeviceData;
      this.detailList = [
        { name: '名称', value: NAME, icon: 'icon_6_1' },
        { name: '设备', value: DEVICE_NAME, icon: 'icon_6_2' },
        { name: '位置', value: ORD, icon: 'icon_6_3' },
        { name: '状态', value: '待排查', icon: 'icon_6_4' },
        {
          name: '描述',
          value: INFO || '-',
          icon: 'icon_6_5',
        },
      ];

      // this.$Model.i3dInit();
      console.log(
        '是否是已排查已出现 :>> ',
        this.curCheckedRedDeviceList.includes(modelDeviceCode)
      );
      if (modelDeviceCode && !this.curCheckedRedDeviceList.includes(modelDeviceCode)) {
        setTimeout(() => {
          this.$Model.i3dHighLight([modelDeviceCode], 'T2', '1', '3');
        }, 300);
      }
      // this.$Model.i3dHighLight([modelDeviceCode], 'T2', '1', '3');
      this.curTable = 2;
      this.getItemInfo();
      this.$forceUpdate();
    },
    dealState(state) {
      const colorMap = {
        0: '1',
        1: '-1',
      };
      this.curTable = 1;
      this.curTableHeight = 660;

      const { ID, modelDeviceCode } = this.curDeviceData;

      // 假数据操作开始
      // this.curUncheckListData.shift();
      // this.$Model.i3dInit();
      if (modelDeviceCode) {
        setTimeout(() => {
          this.$Model.i3dHighLight([modelDeviceCode], 'T2', '1', colorMap[state]);
        }, 300);
      }
      // 假数据操作结束

      console.log(11111111111111);
      // 演示环境暂时不请求该接口
      Api.updateFaultState({
        taskId: this.curCheckTaskId,
        confidence: state,
        info: '',
        faultId: ID,
        stationId: '17230100205',
        isDeleted: 0,
      }).then((res) => {
        // this.$Model.i3dInit();
        console.log(res);
        setTimeout(() => {
          // this.$bus.$emit('isFresh', true);
          const { faultId } = this.curFaultInfo;
          this.refreshFaultsLIst(faultId);
        }, 500);
      });

      this.$forceUpdate();
    },
    getItemInfo() {
      Api.searchFaultStateByFault({
        stationId: '901901000019',
        faultId: '17230100202|1#机组|2925acee5cd84c508642efe802e00b0f',
      });
    },
    getNextstepData(id) {
      this.isLoading = true;
      this.isEmpty = false;
      this.curUncheckListData = [];
      // this.emptyText = '数据请求中';
      // 这里因为后台拿数据比较慢 需要在60s内重复请求，直到拿到数据，否则显示无排查项
      // 这里演示用10秒
      let remainingSeconds = 10;
      clearInterval(timer);
      timer = setInterval(() => {
        console.log(remainingSeconds); // 打印剩余秒数

        Api.getNextstepData({ id }).then((res) => {
          if (res.data != '-1') {
            clearInterval(timer);
            this.isLoading = false;
            const { data } = res.data;
            console.log('data :>> ', data);

            //对待排查项根据发生率进行排序
            data.faults = data.faults.sort((item1, item2) => item2.CONFIDENCE - item1.CONFIDENCE);

            this.showCheckOver = this.dealShowCheckOver(data);
            if (data.faults.length > 0) {
              this.curUncheckListData = data.faults;
            } else {
              this.isEmpty = true;
              this.emptyText = '暂无待排查项';
            }
            this.curFaultTreeData = data;
            this.heightLightOther();
          }
        });

        if (remainingSeconds === 1) {
          this.isLoading = false;
          clearInterval(timer); // 停止计时器
          this.emptyText = '暂无待排查项';
          console.log('倒计时结束');
        }

        remainingSeconds--;
      }, 1000);
    },
    handleClickCheckOver(type) {
      console.log('诊断完成');
      const { faults_checked } = this.curFaultTreeData;
      const { faultId, name } = this.curFaultInfo;
      const param = {
        name: name,
        faultId: faultId,
        confidence: '1.0',
        reasonId: faults_checked[0].ID, //根因id，从已经诊断出现的列表拿
        comment: '诊断完成', //用户要填的数据，写死
        id: this.curTaskId, //任务ID
        status: 3,
        initResult: name,
        station: '17230100205',
      };

      Api.updateTask(param).then((res) => {
        console.log(res);
      });
    },
    dealShowCheckOver(data) {
      let showStatus = false;
      const { faults, faults_checked } = data;
      const faultsAll = [...faults, ...faults_checked];
      console.log('faultsAll', faultsAll);
      if (faults_checked.length > 0) {
        showStatus = true;
      }
      return showStatus;
    },
    refreshFaultsLIst(id) {
      // 刷新排查项列表
      this.isLoading = true;
      this.isEmpty = false;
      Api.getNextStepWithTree({
        fdpId: id,
        stationId: '17230100205',
      }).then((res) => {
        console.log('res :>> ', res);
        if (res.success) {
          this.isLoading = false;
          const { data } = res;
          this.showCheckOver = this.dealShowCheckOver(data);
          if (data.faults.length > 0) {
            this.curUncheckListData = data.faults;
          } else {
            this.isEmpty = true;
            this.emptyText = '暂无待排查项';
          }
          this.curFaultTreeData = data;
          this.heightLightOther();
        }
      });
    },
    // 自动高亮已排查项和待排查项
    heightLightOther() {
      const { faults, faults_checked } = this.curFaultTreeData;
      console.log('this.curRedDeviceCode', this.curRedDeviceCode);
      let faultsList = [];
      let yesList = [];
      let noList = [];
      if (faults.length > 0) {
        faults.forEach((item) => {
          if (item.modelDeviceCode && item.modelDeviceCode != this.curRedDeviceCode) {
            faultsList.push(item.modelDeviceCode);
          }
        });
      }
      if (faults_checked.length > 0) {
        faults_checked.forEach((item) => {
          if (item.modelDeviceCode && item.modelDeviceCode != this.curRedDeviceCode) {
            if (item.STATUS == 1) {
              yesList.push(item.modelDeviceCode);
            } else {
              noList.push(item.modelDeviceCode);
            }
          }
        });
        this.curCheckedRedDeviceList = yesList;
        if (faultsList.length > 0) {
          this.$Model.i3dHighLight(faultsList, 'T2', '5', '3'); //黄色不要标
        }
        if (noList.length > 0) {
          setTimeout(() => {
            this.$Model.i3dHighLight(noList, 'T2', '2', '1'); //绿色不要标
          }, 300);
        }
        if (yesList.length > 0) {
          setTimeout(() => {
            this.$Model.i3dHighLight(yesList, 'T2', '5', '-1'); //红色不要标
          }, 600);
        }
      }
    },
  },
  beforeDestroy() {
    this.$bus.$off('warmFromIndex');
    this.$bus.$off('checkFaultId');
  },
};
</script>

<style lang="scss" scoped>
.side_content {
  width: 112px;
  // height: 218px;
  // background: rgb(10, 30, 56, 0.85);
  background: url('../../assets/hs/bg_次级导航背景.png') no-repeat center;
  position: fixed;
  right: 540px;
  background-size: 100% 100%;
  top: 115px;
  z-index: 99;
  .side_item {
    width: 90px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    text-shadow: 0 0 9px #158eff;
    margin: 15px auto;
    cursor: pointer;
    &.active {
      background: url('../../assets/hs/btn次级导航选中.png') no-repeat center;
      color: #fff;
    }
  }
}
.card_table {
  width: 480px;
  height: 660px;
  margin-top: 12px;
  border: 1px solid;
  border-color: rgba(36, 87, 130, 0.52);
  color: rgba(190, 225, 249, 0.8) !important;
  &.table2 {
    height: 400px;
  }
}
.card_detail {
  padding: 12px 8px;
  .list_item {
    align-items: flex-start;
    margin-bottom: 10px;
    .icon {
      width: 16px;
      height: 20px;
      display: flex;
      align-items: center;
    }
    .name {
      width: 30px;
      margin-left: 8px;
    }
    .value {
      width: 380px;
      margin-left: 15px;
    }
  }
  .btn_box {
    width: 462px;
    margin-top: 13px;
    .btn {
      width: 228px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      position: relative;
      cursor: pointer;
      &:nth-child(1) {
        background: linear-gradient(360deg, #ffea63 0%, rgba(192, 146, 43, 0.7) 100%);
      }
      &:nth-child(2) {
        background: linear-gradient(360deg, #56ade5 0%, rgba(45, 142, 216, 0.7) 100%);
      }
      &::before {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 0 0;
        border-color: #092c51 transparent transparent transparent;
        transform: rotate(0deg);
      }
      &:active {
        opacity: 0.85;
      }
    }
  }
}
</style>
